import React from 'react';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import Column from './Column';
/**
 * Centers prose/reading content to a comfortable line length on desktop.
 * On phone/tablet it is a transparent passthrough (the layout is already
 * capped to the legacy phone column), so reading widths there are unchanged.
 */
const ReadingColumn = ({ style, ...rest }) => {
    const [{ deviceType }] = useTheme();
    return (React.createElement(Column, { style: [
            deviceType.isDesktop && {
                width: '100%',
                // maxWidth: READING_COLUMN_MAX,
                minWidth: 0,
                alignSelf: 'center',
                overflow: 'hidden',
            },
            style,
        ], ...rest }));
};
export default ReadingColumn;
